import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const addNoteDocs = async ({ docId, note }) => {
  return await request.post(
    `/Docs/note`,
    {
      documentId: docId,
      note,
    },
    'При добавлении комментария произошла ошибка',
    'Error'
  );
};

const useAddNoteDocs = () => {
  const mutation = useMutation(addNoteDocs, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocsNote: mutation.isLoading,
    addDocsNote: mutation.mutateAsync,
  };
};

export default useAddNoteDocs;
